import Snackbar from './Snackbar.vue'

const showedMsg = []

function Install (Vue, options) {
  const property = (options && options.property) || '$snackbar'
  function createDialogCmp (options) {
    return new Promise(resolve => {
      const cmp = new Vue(Object.assign(Snackbar, {
        destroyed: (c) => {
        }
      }))
      Object.assign(cmp, Vue.prototype[property].options || {}, options)
      document.body.appendChild(cmp.$mount().$el)
    })
  }

  function show (message, options = {}) {
    options.message = message
    if (options.timeout == null) {
      options.timeout = Math.max(15, Math.ceil(options.message.length / 5) * 1000)// 5个字1秒
      if (options.color === 'error') { // 错误信息需要手动关闭
        options.timeout = 99999999
      }
    }
    options.changeShow = (v) => {
      if (v) {
        showedMsg.push(message)
      } else {
        const i = showedMsg.indexOf(message)
        if (i > -1) {
          showedMsg.splice(i, 1)
        }
      }
    }
    if (showedMsg.includes(message)) {
      return null
    }
    return createDialogCmp(options)
  }

  Vue.prototype[property] = show
  Vue.prototype[property].options = options || {}
}

export default Install



// WEBPACK FOOTER //
// ./src/components/Snackbar/index.js